import { useEffect, useState } from 'react';
import { Check, ChevronDown, X } from 'lucide-react';
import { toast } from 'sonner';
import { staticDefinitionService } from '../services/staticDefinitionService';
import { supplyService } from '../services/supplyService';

type Props = { shipmentIds: Array<string | number>; onClose: () => void; onSaved: () => void };

export function BulkServiceTypeModal({ shipmentIds, onClose, onSaved }: Props) {
  const [options, setOptions] = useState<string[]>([]);
  const [selected, setSelected] = useState<string[]>([]);
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    void staticDefinitionService.getByKey('shipment_load_type').then((response: any) => {
      const items = Array.isArray(response?.data?.items) ? response.data.items : [];
      setOptions(items.map((item: any) => String(item.value || '').trim()).filter(Boolean));
    }).catch(() => setOptions([]));
  }, []);

  const toggle = (value: string) => setSelected((current) => current.includes(value) ? current.filter((item) => item !== value) : [...current, value]);

  const save = async () => {
    if (selected.length === 0) return toast.error('En az bir hizmet türü seçin');
    try {
      setSaving(true);
      await supplyService.bulkUpdateServiceType(shipmentIds, selected);
      toast.success(`${shipmentIds.length} kayıt güncellendi`);
      onSaved();
      onClose();
    } catch (error: any) {
      toast.error(error?.message || 'Hizmet türleri güncellenemedi');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl dark:bg-[#171717] dark:text-white">
        <div className="flex items-center justify-between"><div><h2 className="text-lg font-bold">Toplu Hizmet Türü Güncelle</h2><p className="mt-1 text-xs text-slate-500">{shipmentIds.length} sevk siparişi seçildi</p></div><button type="button" onClick={onClose}><X className="h-5 w-5 text-slate-500" /></button></div>
        <label className="mt-5 block text-sm font-semibold">Hizmet Türü</label>
        <div className="relative mt-2">
          <button type="button" onClick={() => setOpen((value) => !value)} className="flex min-h-11 w-full items-center gap-2 rounded-xl border border-slate-300 bg-white px-3 py-2 text-left text-sm dark:border-slate-700 dark:bg-[#111]">
            <span className="flex flex-1 flex-wrap gap-1">{selected.length ? selected.map((item) => <span key={item} className="rounded-lg bg-emerald-100 px-2 py-1 text-xs font-semibold text-emerald-800">{item}</span>) : <span className="text-slate-400">Hizmet türü seçin</span>}</span><ChevronDown className="h-4 w-4 shrink-0 text-slate-400" />
          </button>
          {open && <div className="absolute z-10 mt-1 max-h-64 w-full overflow-auto rounded-xl border border-slate-200 bg-white p-1 shadow-xl dark:border-slate-700 dark:bg-[#171717]">{options.length ? options.map((item) => <button type="button" key={item} onClick={() => toggle(item)} className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm hover:bg-slate-100 dark:hover:bg-white/10"><span className={`flex h-4 w-4 items-center justify-center rounded border ${selected.includes(item) ? 'border-emerald-600 bg-emerald-600 text-white' : 'border-slate-300'}`}>{selected.includes(item) ? <Check className="h-3 w-3" /> : null}</span>{item}</button>) : <div className="p-3 text-sm text-slate-500">Tanımlı hizmet türü bulunamadı</div>}</div>}
        </div>
        <div className="mt-5 flex justify-end gap-2"><button type="button" onClick={onClose} disabled={saving} className="rounded-xl border border-slate-300 px-4 py-2 text-sm dark:border-slate-700">Vazgeç</button><button type="button" onClick={() => void save()} disabled={saving} className="rounded-xl bg-blue-600 px-4 py-2 text-sm font-semibold text-white disabled:opacity-60">{saving ? 'Güncelleniyor...' : 'Uygula'}</button></div>
      </div>
    </div>
  );
}
